/**
 * @generated SignedSource<<2fc729590233a5c73d033e6ef3585349>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AcknowledgePotentialAnalysisMaxRewardInput = {
  clientMutationId?: string | null;
};
export type microLearningReward_AcknowledgePotentialAnalysisMaxRewardMutation$variables = {
  input: AcknowledgePotentialAnalysisMaxRewardInput;
};
export type microLearningReward_AcknowledgePotentialAnalysisMaxRewardMutation$data = {
  readonly PotentialAnalysis: {
    readonly acknowledgePotentialAnalysisMaxReward: {
      readonly clientMutationId: string | null;
    } | null;
  };
};
export type microLearningReward_AcknowledgePotentialAnalysisMaxRewardMutation = {
  response: microLearningReward_AcknowledgePotentialAnalysisMaxRewardMutation$data;
  variables: microLearningReward_AcknowledgePotentialAnalysisMaxRewardMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "PotentialAnalysisMutations",
    "kind": "LinkedField",
    "name": "PotentialAnalysis",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "AcknowledgePotentialAnalysisMaxRewardPayload",
        "kind": "LinkedField",
        "name": "acknowledgePotentialAnalysisMaxReward",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "clientMutationId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "microLearningReward_AcknowledgePotentialAnalysisMaxRewardMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "microLearningReward_AcknowledgePotentialAnalysisMaxRewardMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "31e86325aa247e962341d050180c0d09",
    "id": null,
    "metadata": {},
    "name": "microLearningReward_AcknowledgePotentialAnalysisMaxRewardMutation",
    "operationKind": "mutation",
    "text": "mutation microLearningReward_AcknowledgePotentialAnalysisMaxRewardMutation(\n  $input: AcknowledgePotentialAnalysisMaxRewardInput!\n) {\n  PotentialAnalysis {\n    acknowledgePotentialAnalysisMaxReward(input: $input) {\n      clientMutationId\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "686254dcc64efa692947b0afbae7dbd4";

export default node;
